import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "glasspane",
    id: _ctx.id
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "d-flex justify-content-center align-items-center fa-4x h-100" }, [
      _createElementVNode("div", null, [
        _createElementVNode("i", { class: "fa fa-spin fa-spinner" })
      ])
    ], -1)
  ]))], 8, _hoisted_1))
}